define("settings/templates/subscription/billing/info", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Modal @close={{perform this.handleClose}} as |modal|>
    <modal.card @portrait={{true}}>
      <modal.card-header @title={{t "account.subscription.billing.info.title"}} class="u--p__b" />
      {{! @glint-expect-error ModalForm not typesafe yet }}
      <ModalForm
        @cancel={{modal.close}}
        @runningText={{t "shared_words.saving"}}
        @task={{task this.handleSubmit}}
        as |form|
      >
        <modal.card-body>
          <form.input
            @label={{t "account.subscription.billing.info.description"}}
            @qaClassInputLabel="qa--additionalInformation_title u--text--light u--text--hair"
            class=""
            as |uniqueId|
          >
            <Textarea
              @value={{this.currentAccount.additionalBillingInfo}}
              class="o--form__input {{if this.isEditDisabled 'u--mute'}} qa-additionalInformation_input"
              cols="50"
              disabled={{this.isEditDisabled}}
              id={{uniqueId}}
              placeholder={{t "account.subscription.billing.info.placeholder"}}
              rows="4"
            />
          </form.input>
        </modal.card-body>
        <modal.card-footer>
          <form.footer @submitButtonText={{t "shared_words.save"}} />
        </modal.card-footer>
      </ModalForm>
    </modal.card>
  </Shared::Modal>
  */
  {
    "id": "rPhBDHuq",
    "block": "[[[8,[39,0],null,[[\"@close\"],[[28,[37,1],[[30,0,[\"handleClose\"]]],null]]],[[\"default\"],[[[[1,\"\\n  \"],[8,[30,1,[\"card\"]],null,[[\"@portrait\"],[true]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,1,[\"card-header\"]],[[24,0,\"u--p__b\"]],[[\"@title\"],[[28,[37,2],[\"account.subscription.billing.info.title\"],null]]],null],[1,\"\\n\"],[1,\"    \"],[8,[39,3],null,[[\"@cancel\",\"@runningText\",\"@task\"],[[30,1,[\"close\"]],[28,[37,2],[\"shared_words.saving\"],null],[28,[37,4],[[30,0,[\"handleSubmit\"]]],null]]],[[\"default\"],[[[[1,\"\\n      \"],[8,[30,1,[\"card-body\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"input\"]],[[24,0,\"\"]],[[\"@label\",\"@qaClassInputLabel\"],[[28,[37,2],[\"account.subscription.billing.info.description\"],null],\"qa--additionalInformation_title u--text--light u--text--hair\"]],[[\"default\"],[[[[1,\"\\n          \"],[8,[39,5],[[16,0,[29,[\"o--form__input \",[52,[30,0,[\"isEditDisabled\"]],\"u--mute\"],\" qa-additionalInformation_input\"]]],[24,\"cols\",\"50\"],[16,\"disabled\",[30,0,[\"isEditDisabled\"]]],[16,1,[30,3]],[16,\"placeholder\",[28,[37,2],[\"account.subscription.billing.info.placeholder\"],null]],[24,\"rows\",\"4\"]],[[\"@value\"],[[30,0,[\"currentAccount\",\"additionalBillingInfo\"]]]],null],[1,\"        \"]],[3]]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n      \"],[8,[30,1,[\"card-footer\"]],null,null,[[\"default\"],[[[[1,\"\\n        \"],[8,[30,2,[\"footer\"]],null,[[\"@submitButtonText\"],[[28,[37,2],[\"shared_words.save\"],null]]],null],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[2]]]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[1]]]]]],[\"modal\",\"form\",\"uniqueId\"],false,[\"shared/modal\",\"perform\",\"t\",\"modal-form\",\"task\",\"textarea\",\"if\"]]",
    "moduleName": "settings/templates/subscription/billing/info.hbs",
    "isStrictMode": false
  });
});